import { render, staticRenderFns } from "./BlockInstagram.vue?vue&type=template&id=4a5779fa"
import script from "./BlockInstagram.vue?vue&type=script&lang=js"
export * from "./BlockInstagram.vue?vue&type=script&lang=js"
import style0 from "./BlockInstagram.vue?vue&type=style&index=0&id=4a5779fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports